module.exports = __webpack_public_path__ + "img/Beach.5034bcb4.svg";